const thirtyDaysInSeconds = 60 * 60 * 24 * 30;
// We are setting expiration by duration in seconds, not timestamp of the actual expiration from unix epoch
export function verifyExperimentQueryParam(asPath, testVariant, experimentId) {
  // Extract query params, and check that the provided query param exists and matches the useNewTaxonomy return
  return asPath
    .replace(/^[^?]+[?]?/, '')
    .split('&')
    .includes(`${experimentId}=${testVariant ? 1 : 0}`);
}

export function updateABTestCookie(res, testVariant, testCookieId) {
  // Cookie setting taken from PHP side
  // Secure false, httponly true, cookie expires 30 day from creation/re-issue

  let cookieParams = {
    name: 'set-cookie',
    value: `${testCookieId}=${
      testVariant ? 1 : 0
    }; Path=/; Max-Age=${thirtyDaysInSeconds}; Domain=.education.com; HttpOnly`,
  };

  res.setHeader(cookieParams.name, cookieParams.value);
}
